import { HTTPResponse } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

export interface ClaimFreeSpinsPayload {
  freeBetId: number;
  gameIds: number[];
}

class FreeSpinsController extends BaseApiService {

  public async claim(payload: ClaimFreeSpinsPayload): Promise<HTTPResponse> {
    const url = `${this.url}/api/freebets/claim`;
    return await this.http.post(url, payload, { skipInterceptor: true });
  }

  public async markAsSeen(id: number): Promise<HTTPResponse> {
    const url = `${this.url}/api/freebets/${id}/seen`;
    return await this.http.put(url, {}, { skipInterceptor: true });
  }

}

export const freeSpinsController = new FreeSpinsController({ url: env.origin });
